// extracted by mini-css-extract-plugin
export default {"gameNotFoundMain":"GameNotFound_gameNotFoundMain__YCsf8"};